<template>
  <copyable-code
    :code="data.uuid"
    :length="8"
  />
</template>

<script>
import CopyableCode from '../../common/CopyableCode'

export default {
  components: {
    CopyableCode
  },
  data() {
    return {
      data: {},
    }
  }
}
</script>